$(document).ready(function () {
  /*
  // $('#__ba_panel').addClass('is-hidden')

  // Show browsealoud widget when clicking link in footer
  $('a[href="#browsealoud"]').on('click', function(e) {
    e.preventDefault()
    $('#__ba_panel').show()
    $('#__ba_panel a').click()
  })
*/
  var selectId = $("#pl_category_id");


  $(selectId).on("change", function (e) {
    //e.preventDefault();

    var url = window.location.href;
    var isPagination = url.split("?")[0].indexOf("/page/");
    if (isPagination) {
      $(selectId)
        .closest("form")
        .attr("action", url.substr(0, isPagination + 1));
    }
    $(selectId).closest("form").submit();
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Category Filter
   *--------------------------------------------------------------------------
   */
  $(".c-category-filters__title").click(function () {
    $("main#main").toggleClass("u-no-overflow");
    $(".c-category-filters__menu").toggleClass("open").slideToggle(200);
    $(this).toggleClass("active");
    $(".c-category-filters__arrow").toggleClass("open");
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Site nav
   *--------------------------------------------------------------------------
   */
  var $siteNav = $(".c-site-nav");
  var $siteNavToggle = $(".js-site-nav--toggle");
  var $siteNavItem = $(".c-site-nav__item");

  $siteNavToggle.on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var isActive = $siteNav.hasClass("is-active");
    if (!isActive) {
      // Show Nav
      $this.addClass("is-active");
      $siteNav.addClass("is-active");
      $this.attr("aria-expanded", "true");
      $siteNav.attr("aria-hidden", "false");
      $siteNav
        .find(".c-site-nav__menu:first-of-type .c-site-nav__item:first-of-type")
        .focus();
    } else {
      // Hide Nav
      $this.removeClass("is-active");
      $siteNav.removeClass("is-active");
      $this.attr("aria-expanded", "false");
      $siteNav.attr("aria-hidden", "true");
    }
  });

  if ($(window).width() < 992) {
    // Main dropdown
    $(".c-site-nav__dropdown")
      .parent()
      .find("> .c-site-nav__link")
      .on("click", function (e) {
        e.preventDefault();
        var submenu = $(this).parent().children(".c-site-nav__dropdown");
        if ($(submenu).is(":hidden")) {
          $(submenu).slideDown(200);
          $(submenu).parent().addClass("is-open");
        } else {
          $(submenu).slideUp(200);
          $(submenu).parent().removeClass("is-open");
        }
      });
  }

  $siteNavItem.hover(
    function (e) {
      var $this = $(this);
      $this.addClass("is-active");
      var $thisDropdown = $this.find(".c-site-nav__dropdown");

      if ($thisDropdown.length >= 1) {
        // do something with the dropdown
      }
    },
    function () {
      $(this).removeClass("is-active");
    }
  );

  jQuery(".c-sub-nav, .c-sub-nav__panel").menuAim({
    activate: activateSubNav,
    deactivate: deactivateSubNav,
    exitMenu: deactivateSubNav,
  });

  function activateSubNav(row) {
    jQuery(row).addClass("is-active");
  }

  function deactivateSubNav(row) {
    jQuery(row).removeClass("is-active");
    jQuery(row).find(".c-sub-nav__item").removeClass("is-active");
    return true;
  }

  /**
   *--------------------------------------------------------------------------
   * Component: Emergency Notice
   *--------------------------------------------------------------------------
   */

  var $noticeClose = $(".c-emergency-notice__close");
  $noticeClose.click(function () {
    // Close Notice
    $(this).parent().addClass("is-closed");
  });
  /**
   *--------------------------------------------------------------------------
   * Component: Carousel
   *--------------------------------------------------------------------------
   */
  $(".c-carousel__item-list").slick({
    accessibility: true,
    arrows: true,
    appendArrows: ".c-carousel__arrows",
    nextArrow:
      '<button type="button" class="slick-next u-hide-text">Next Slide</button>',
    prevArrow:
      '<button type="button" class="slick-prev u-hide-text">Previous Slide</button>',
    centerMode: true,
    dots: true,
    dotsClass: "c-carousel__dots",
    appendDots: ".c-carousel__dots-container",
    infinite: false,
    mobileFirst: true,
    variableWidth: false,
    centerPadding: "30px",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
          speed: 400,
          fade: true,
          cssEase: "linear",
        },
      },
    ],
  });
  /**
   *--------------------------------------------------------------------------
   * Component: Featured Content Slider
   *--------------------------------------------------------------------------
   */

  $(".c-featured-content-slider__slider").slick({
    accessibility: true,
    arrows: true,
    nextArrow:
      '<button type="button" class="c-featured-content-slider__arrow-button slick-next">Next Slide</button>',
    prevArrow:
      '<button type="button" class="c-featured-content-slider__arrow-button slick-prev">Previous Slide</button>',
    centerMode: false,
    dots: false,
    infinite: true,
    mobileFirst: true,
    variableWidth: false,
    centerPadding: "30px",
    dotsClass: "c-featured-content-slider__dots",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          speed: 400,
          fade: true,
          cssEase: "linear",
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Accordion
   *--------------------------------------------------------------------------
   */
  var $accordion = $(".c-accordion");
  var $accordionItem = $(".c-accordion__item");
  var $accordionTitle = $(".c-accordion__title");
  var $accordionContents = $(".c-accordion__content");

  $(".c-accordion").each(function () {
    if (!$(this).hasClass("close-it")) {
      $(this).find(".c-accordion__item:first-child").addClass("is-active");
      // (Optional) Active an item if it has the class "is-active"
      $(this)
        .find(".c-accordion__item.is-active")
        .children(".c-accordion__content")
        .slideDown();
      if ($(this).find(".c-accordion__item").length < 2) {
        $(this).find(".c-accordion__item:first-child").addClass("is-active");
      }
    }
  });

  $accordionTitle.click(function (e) {
    e.preventDefault();
    var timeoutID;
    var $this = $(this);

    if ($(".c-accordion__item.scrollup").length) {
      smoothScrollToElement($this, 300);
      console.log("yes yes");
    }

    /*
    if ( $('.c-accordion__item.scrollup')) {
	     smoothScrollToElement($this, 300)
	     console.log('yes')
    }
*/

    // Cancel other parents
    $(this)
      .parent()
      .siblings(".c-accordion__item")
      .removeClass("is-active")
      .children(".c-accordion__content")
      .slideUp();

    // Toggle the item
    $this
      .parent()
      .toggleClass("is-active")
      .children(".c-accordion__content")
      .slideToggle("ease-out", function () {
        // when complete smooth scroll to the top of the item

        if ($(".c-accordion__item.scrollup").length) {
          smoothScrollToElement($this, 300);
          console.log("yes yes");
        }
      });
  });

  /**
   *--------------------------------------------------------------------------
   * Useful links in the header (Services)
   *--------------------------------------------------------------------------
   */

  if ($(window).width() < 1009) {
    if ($(".c-useful-links").hasClass("c-useful-links--in-header")) {
      $(".c-useful-links--in-header").insertAfter(".c-breadcrumbs");
      $(".c-accordion--useful-links__item").removeClass("is-active");
      $(".c-accordion--useful-links__content").slideUp();
    }
  } else {
    if ($(".c-useful-links").hasClass("c-useful-links--in-header")) {
      $(".c-useful-links--in-header .c-accordion--useful-links__title").off(
        "click"
      );
      $(".l-content-page__aside").prepend($(".c-useful-links--in-header"));
      $(".c-accordion__item").unbind("click");
    }
  }

  /*
  /**
  *--------------------------------------------------------------------------
  * Event Maps
  *--------------------------------------------------------------------------
  */
  /*
  $('.js-event-detail-map').each(function(){

    // create map
    map = new_map( $(this) );

  });
  */

  /**
   *--------------------------------------------------------------------------
   * Scroll to top link
   *--------------------------------------------------------------------------
   */
  // Check to see if the window is top if not then display button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".js-scroll-to-top").fadeIn();
    } else {
      $(".js-scroll-to-top").fadeOut();
    }
  });

  // Change focus to the top most link, in this case Skip to content
  $(".js-scroll-to-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 800);
    $("#top-focus").focus();
    return false;
  });

  /**
   *--------------------------------------------------------------------------
   * Smooth Scroll: (any link with class .js-smooth-scroll)
   *--------------------------------------------------------------------------
   */
  $(".js-smooth-scroll").click(function () {
    smoothScrollToElement(this);
  });

  function smoothScrollToElement(el, speed) {
    var speed = speed || 800;
    var elementToScrollToID = $(el).attr("href");
    $("html, body").animate(
      {
        scrollTop: $(elementToScrollToID).offset().top - 10,
      },
      speed
    );
  }

  /**
   *--------------------------------------------------------------------------
   * Component: Modal
   *--------------------------------------------------------------------------
   */

  var $modal = $(".c-modal");
  var $modalOverlay = $(".c-modal-overlay");

  $(".js-modal-toggle").on("click", function (e) {
    e.preventDefault();
    var modalId = $(this).attr("data-modal-id");
    var $modal = $("#" + modalId);
    // toggle modal & overlay
    $modal.toggleClass("is-closed");
    $modalOverlay.toggleClass("is-closed");
  });

  // Close all modals and overlay when clicking on the overlay
  $modalOverlay.on("click", function (e) {
    $(this).addClass("is-closed");
    $(".c-modal").addClass("is-closed");
    stopVideo();
    var $audio = document.getElementById("audio");
    $audio.pause();
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Patient Library
   *--------------------------------------------------------------------------
   */

  var $allModals = $(".c-modal");

  // Patient library - Toggle video overlay
  $(".js-patient-library__toggle-video").on("click", function (e) {
    e.preventDefault();
    var modalId = $(this).attr("data-modal-id");
    var videoId = $(this).attr("data-video-id");
    var $modal = $("#" + modalId);

    // Set new video src on vimeo iframe
    if (modalId == "youtube-video-modal") {
      // for youtube
      var newSrc =
        "https://www.youtube.com/embed/" + videoId + "?rel=0&amp;showinfo=0";
    } else {
      // for vimeo
      var newSrc =
        "https://player.vimeo.com/video/" +
        videoId +
        "?color=ffffff&title=0&byline=0&portrait=0";
    }
    $modal.find("iframe").attr("src", newSrc);

    // resize video iframe to fit contents
    var newWidth = $modal.find(".o-video").width();
    $modal
      .find("iframe")
      .width(newWidth)
      .height(newWidth * $modal.find("iframe").attr("data-aspectRatio"));
    $modal.height(newWidth * $modal.find("iframe").attr("data-aspectRatio"));
  });

  $(".js-patient-library__toggle-audio").on("click", function (e) {
    e.preventDefault();
    var newSrc = $(this).attr("data-audio-src");
    var modalId = $(this).attr("data-modal-id");
    var $modal = $("#" + modalId);
    var $audio = document.getElementById("audio");
    var $source = document.getElementById("audioSource");
    console.log(newSrc);
    $source.src = newSrc;
    $audio.load();
    $audio.play();
  });

  $(window)
    .resize(function () {
      $allModals.each(function () {
        var $el = $(this);
        var newWidth = $el.find(".o-video").width();
        $el.height(newWidth * $modal.find("iframe").attr("data-aspectRatio"));
      });
    })
    .resize();

  /**
   *--------------------------------------------------------------------------
   * Component: Video
   *--------------------------------------------------------------------------
   */
  var $allVideos = $(".o-video > iframe, object, embed");
  var $fluidEl = $(".o-video");

  // $ .data does not work on object/embed elements
  $allVideos.each(function () {
    $(this)
      .attr("data-aspectRatio", this.height / this.width)
      .removeAttr("height")
      .removeAttr("width");
  });

  $(window)
    .resize(function () {
      var newWidth = $fluidEl.width();

      $allVideos.each(function () {
        var $el = $(this);
        $el.width(newWidth).height(newWidth * $el.attr("data-aspectRatio"));
      });
    })
    .resize();

  function stopVideo() {
    var $frame = $("iframe.vimeo-video");

    // saves the current iframe source
    var vidsrc = $frame.attr("src");

    // sets the source to nothing, stopping the video
    $frame.attr("src", "");

    // sets it back to the correct link so that it reloads immediately on the next window open
    $frame.attr("src", vidsrc);
  }

  /* Replace all SVG images with inline SVG when Class 'svg' is used. */
  $("img.svg").each(function () {
    var $img = $(this);
    var imgID = $img.attr("id");
    var imgClass = $img.attr("class");
    var imgURL = $img.attr("src");

    $.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find("svg");

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== "undefined") {
          $svg = $svg.attr("id", imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== "undefined") {
          $svg = $svg.attr("class", imgClass + " replaced-svg");
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr("xmlns:a");

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      "xml"
    );
  });

  function handleTwitterIntentLinks(params) {
    if (window.__twitterIntentHandler) return;
    var intentRegex = /twitter\.com\/intent\/(\w+)/;
    var windowOptions = "scrollbars=yes,resizable=yes,toolbar=no,location=yes";
    var width = 550;
    var height = 420;
    var winHeight = window.screen.height;
    var winWidth = window.screen.width;

    function handleIntent(e) {
      e = e || window.event;
      var target = e.target || e.srcElement;

      var m;
      var left;
      var top;

      while (target && target.nodeName.toLowerCase() !== "a") {
        target = target.parentNode;
      }

      if (target && target.nodeName.toLowerCase() === "a" && target.href) {
        m = target.href.match(intentRegex);
        if (m) {
          left = Math.round(winWidth / 2 - width / 2);
          top = 0;

          if (winHeight > height) {
            top = Math.round(winHeight / 2 - height / 2);
          }

          window.open(
            target.href,
            "intent",
            windowOptions +
              ",width=" +
              width +
              ",height=" +
              height +
              ",left=" +
              left +
              ",top=" +
              top
          );
          e.returnValue = false;
          e.preventDefault && e.preventDefault();
        }
      }
    }

    if (document.addEventListener) {
      document.addEventListener("click", handleIntent, false);
    } else if (document.attachEvent) {
      document.attachEvent("onclick", handleIntent);
    }
    window.__twitterIntentHandler = true;
  }
  handleTwitterIntentLinks();

  $(".js-emergency-takeover__toggle").on("click", function (e) {
    var is_persistent = $(this).attr("data-is-persistent");
    var takeover_uid = $(this).attr("data-uid");

    var data = {
      action: "mft_emergency_takeover_closed",
      is_persistent: is_persistent,
      takeover_uid: takeover_uid,
    };

    $.post(ajaxurl, data, function (response) {
      console.log(response);
    });
  });

  // Message popup
  $(".c-message-popup__link").on("click", function (e) {
    e.preventDefault();
    var popup_uid = $(this)
      .parents()
      .find(".c-message-popup__toggle")
      .attr("data-uid");
    var data = {
      action: "mft_message_popup_closed",
      // is_persistent: is_persistent,
      popup_uid: popup_uid,
    };
    $.post(ajaxurl, data, function (response) {
      console.log(response);
      window.location.href = $(".c-message-popup__link").attr("href");
    });
  });

  $(".js-message-popup__toggle").on("click", function (e) {
    // var is_persistent = $(this).attr('data-is-persistent');
    var popup_uid = $(this).attr("data-uid");

    var data = {
      action: "mft_message_popup_closed",
      // is_persistent: is_persistent,
      popup_uid: popup_uid,
    };

    $.post(ajaxurl, data, function (response) {
      console.log(response);
    });
  });

  //Course filter
  function showTheUrl() {
    event.preventDefault();
    var d1 = $("#courseType").find(":selected").attr("value");
    var d2 = $("#courseLocation").find(":selected").attr("value");
    var origin   = window.location.origin; 
    if (d1 !== '' && d2 === '') {
        //console.log('Type')
        //console.log(d1)
        //console.log(d2)
        var url = encodeURI(origin + "/course-search/?courseType=" + d1);
    } else if (d1 !== '' && d2 !== ''){
         //console.log('Both')
         //console.log(d1, d2)
         var url = encodeURI(origin + "/course-search/?courseType=" + d1 + "&courseLocation=" + d2);
    } else if (d1 === '' && d2 !== ''){
         //console.log('Location')
         //console.log(d1, d2)
         var url = encodeURI(origin + "/course-search/?courseLocation=" + d2);
    } else if (d1 === 'all' && d2 === 'all'){
         //console.log('Location')
         //console.log(d1, d2)
         var url = encodeURI(origin + "/course-search/?courseType=" + d1 + "&courseLocation=" + d2);
    } 

    //alert(url);
    //console.log(url)
    
    document.location = url;

} 
function urlAnalyze(url) {
    if (url == undefined) {
        var url = document.location.toString();
    }
    url = unescape(url);
    //seperates the parts of the url
    var parts = url.split("?");
    //splits into sperate key=values
    if (parts[1] == undefined) {
        return 1;
    }
    var keyValues = parts[1].split("&");
    var key = function () {}
    keyValues.forEach(function (keyValue) {
        var keyAndValue = keyValue.split("=");
        key[keyAndValue[0]] = keyAndValue[1];
    });
    return key;
}

$('#submit').click(showTheUrl);

});
